import { makeStyles } from "@material-ui/core/styles";
export default makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  bienvenida: {
    width: "100%",
    height: "auto",
    overflow: "hidden",
    margin: "0",
    position: "relative",
  },
  imagenBienvenida:{
    width: "100%",
    height: "100vh",
    overflow: "hidden",
    margin: "0",
    position: "relative",
  }
}));
